import React, { useEffect, useState } from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import ArticleContent from './articleContent';

const Article = ({ content }) => {
    useEffect(() => {}, []);
    const { contentData, videosPluginData, slidesPluginData, surveyPluginData, goodsPlugin, title, newsTime, catename, lastArticleAddress } = content;
    const pluginData = {
        videosPluginData,
        slidesPluginData,
        surveyPluginData,
        goodsPlugin,
    };

    return (
        <>
            <div className={styles.title}>{title}</div>
            <div className={styles.info}>
                {newsTime} {catename} {lastArticleAddress}
            </div>
            <div className={styles.content}>
                <ArticleContent content={contentData} pluginData={pluginData} />
            </div>
        </>
    );
};

Article.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Article);
